import script from "./ZHighlightedBlock.vue?vue&type=script&setup=true&lang=js"
export * from "./ZHighlightedBlock.vue?vue&type=script&setup=true&lang=js"

import "./index.scss?vue&type=style&index=0&lang=scss"

const __exports__ = script;

export default __exports__